module.exports = __webpack_public_path__ + "img/logo-um-fl-ang.b00d2912.png";